import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import { addToCart } from "../../store/actions/action";
import PopupQuickview from '../PopupQuickview/PopupQuickview';
import './shope.css'




import Shape1 from '../../images/product/shape-1.png';
import Shape2 from '../../images/product/shape-2.png';
import proimage1 from '../../images/product/dorowot.avif'
import kitfo from '../../images/product/kitfo.jpg'
import Alicha from '../../images/product/alicha watt.jpg'
import tibs from '../../images/product/selective-focus-shot-delicious-ethiopian-food-with-fresh-vegetables-wooden-table.jpg'
import sigawatt from '../../images/product/Sega-Wat-2-cropped.jpg'
import whiteinjera from '../../images/product/white injera.jpg'
import redinjera from '../../images/product/red injera.jpg'
import cini from '../../images/product/cini.png'
import coffetable from '../../images/product/bunna  table.jpg'
import forks from '../../images/product/fork-619148_640.jpg'
import berbere from '../../images/product/berberie.png'
import mesob from '../../images/product/ethiopia mesob21.png'
import mitad from '../../images/product/mitsd.png'
import plates from '../../images/product/31213.jpg'
import kinche from '../../images/product/kinche.jpg'
import korerima from '../../images/product/korerima.jpg'
// import jebena from '../../images/product/coffee-2895730_640.jpg'
import shiro from '../../images/product/image.png'
import tiresiga from '../../images/product/ethiopian tire siga.jpg'
import siga from '../../images/product/siga.webp';
import kocho from '../../images/product/kocho.webp'
import bulabseso from '../../images/product/Bula beso ena yegenfo ehile.png'
import cookies from '../../images/product/cookies.jpg'  
import datesrowhoney from '../../images/product/honey-jars-with-bee-smoker-honeycomb.jpg'
import tikurazmud from '../../images/product/tikur azmud.jpg'
import abesh from '../../images/product/Abesh.webp'
import jebena from '../../images/product/jebena for coffe.jpg'
import santa from '../../images/product/Copilot_20250611_040506.png'



const productData = [
 
  {
    id: 3,
    proImg: plates,
    singImg: plates,
    title: "ሳንቃ",  // plates
    slug: "Cauliflower",
    brand: "Organic Food",
    size: "L",
    category: "Household Needs"
  },
  {
    id: 4,
    proImg: whiteinjera,
    singImg: whiteinjera,
    title: "ነጭ እንጀራ",  // white Injera
    slug: "Yellow-Corn",
    brand: "Organic Food",
    size: "M",
    category: "Injera"
  },
  {
    id: 5,
    proImg: coffetable,
    singImg: coffetable,
    title: "የቡና ጠረጴዛ",  // Coffee table
    slug: "Red-Onion",
    brand: "Organic Food",
    size: "XXl",
    category: "Household Needs"
  },
  {
    id: 6,
    proImg: forks,
    singImg: forks,
    title: "ፎርኮች",  // Forks
    slug: "Lens-Broccoli",
    brand: "Organic Food",
    size: "Xl",
    category: "Household Needs"
  },
  {
    id: 7,
    proImg: redinjera,
    singImg: redinjera,
    title: "ጥቁር እንጀራ",  // brown injera
    slug: "Orange-Paprika",
    brand: "Organic Food",
    size: "Xl",
    category: "Injera"
  },
  {
    id: 9,
    proImg: proimage1,
    singImg: proimage1,
    title: "ዶሮ ወጥ",  // Doro Wat
    slug: "Doro-Wat",
    brand: "Ethiopian Delight",
    size: "Large Tray",
    category: "Catering Services"
  },
  {
    id: 10,
    proImg: sigawatt,
    singImg: sigawatt,
    title: "ስጋ ወጥ",  // Siga Wat
    slug: "Siga-Wat",
    brand: "Ethiopian Delight",
    size: "Large Tray",
    category: "Catering Services"
  },
  {
    id: 11,
    proImg: tibs,
    singImg: tibs,
    title: "ጥብስ",  // Tibs
    slug: "Tibs",
    brand: "Ethiopian Delight",
    size: "Medium Tray",
    category: "Catering Services"
  },
  {
    id: 12,
    proImg: kitfo,
    singImg: kitfo,
    title: "ክትፎ",  // Kitfo
    slug: "Kitfo",
    brand: "Ethiopian Delight",
    size: "Medium Tray",
    category: "Catering Services"
  },
  {
    id: 29,
    proImg: Alicha,
    singImg: Alicha,
    title: "አሊጫ ወጥ",  // Alicha Wot
    slug: "Alicha-Wot",
    brand: "Ethiopian Delight",
    size: "Large Tray",
    category: "Catering Services"
  },
  
  {
    id: 30,
    proImg: tiresiga,
    singImg: tiresiga,
    title: "ጥሬ ስጋ",  // Tire siga
    slug: "Tire siga",
    brand: "Ethiopian Delight",
    size: "Large Tray",
    category: "Catering Services"
  },
  {
    id: 13,
    proImg: kocho,
    singImg: kocho,
    title: "ኢትዮጵያ ቆጮ",  // Ethiopia kocho
    slug: "Ethiopia kocho",
    brand: "Ethiopian Delight",
    size: "Large Tray",
    category: "Catering Services"
  },
  {
    id: 14,
    proImg: jebena,
    singImg: jebena,
    title: "ጀበና (ባህላዊ የቡና ድስት)",  // Jebena
    slug: "jebena-coffee-pot",
    brand: "Ethiopian Crafts",
    size: "Medium",
    category: "Household Needs"
  },
  {
    id: 15,
    proImg: mesob,
    singImg: mesob,
    title: "ሜሶብ (የምግብ አቅራቢ መከለያ)",  // Mesob
    slug: "mesob-serving-basket",
    brand: "Ethiopian Crafts",
    size: "Large",
    category: "Household Needs"
  },
  {
    id: 16,
    proImg: mitad,
    singImg: mitad,
    title: "ምጣድ (የእንጀራ እቃ)",  // Mitad
    slug: "mitad-injera-cooker",
    brand: "Ethiopian Crafts",
    size: "Standard",
    category: "Household Needs"
  },
  {
    id: 17,
    proImg: cini,
    singImg: cini,
    title: "ስኒ (የቡና ኩባያዎች)",  // Cini
    slug: "cini-coffee-cups",
    brand: "Ethiopian Crafts",
    size: "Set of 6",
    category: "Household Needs"
  },
  
  {
    id: 20,
    proImg: santa,
    singImg:santa,
    title: "ሻንጣ",  // Traditional Coffee Set
    slug: "traditional-coffee-set",
    brand: "Ethiopian Crafts",
    size: "Complete Set",
    category: "Household Needs"
  },
  {
    id: 21,
    proImg: berbere,
    singImg:berbere,
    title: "በርበሬ ቅመም",  // Berbere Spice
    slug: "berbere-spice",
    brand: "Organic Food",
    size: "200g",
    category: "Spices & Ingredients"
  },
  {
    id: 22,
    proImg: berbere,
    singImg: berbere,
    title: "ሚትሚታ ቅመም",  // Mitmita Spice
    slug: "mitmita-spice",
    brand: "Organic Food",
    size: "150g",
    category: "Spices & Ingredients"
  },
  {
    id: 23,
    proImg: shiro,
    singImg: shiro,
    title: "ሽሮ ዱቄት",  // Shiro Powder
    slug: "shiro-powder",
    brand: "Organic Food",
    size: "250g",
    category: "Spices & Ingredients"
  },
  {
    id: 24,
    proImg: kinche,
    singImg: kinche,
    title: "ክንቺ (የተሰነጠቀ ስንዴ)",  // Kinche
    slug: "kinche-cracked-wheat",
    brand: "Organic Food",
    size: "1kg",
    category: "Spices & Ingredients"
  },
  {
    id: 25,
    proImg: korerima,
    singImg: korerima,
    title: "ኮረሪማ (ጥቁር ካርዳሞም)",  // Korerema
    slug: "korerema-black-cardamom",
    brand: "Organic Food",
    size: "100g",
    category: "Spices & Ingredients"
  },
   {
    id: 27,
    proImg: bulabseso,
    singImg:bulabseso,
    title: "ቡላ በሶ",  // Berbere Spice
    slug: "berbere-spice",
    brand: "Organic Food",
    size: "200g",
    category: "Spices & Ingredients"
  },
   {
    id: 28,
    proImg: abesh,
    singImg:abesh,
    title: "አብሽ",  // Berbere Spice
    slug: "berbere-spice",
    brand: "Organic Food",
    size: "200g",
    category: "Spices & Ingredients"
  },
   {
    id: 29,
    proImg: tikurazmud,
    singImg:tikurazmud,
    title: "ጥቁር ኣዝሙድ",  // Berbere Spice
    slug: "berbere-spice",
    brand: "Organic Food",
    size: "200g",
    category: "Spices & Ingredients"
  },
   {
    id: 30,
    proImg: datesrowhoney,
    singImg:datesrowhoney,
    title: "Dates row honey",  // Berbere Spice
    slug: "berbere-spice",
    brand: "Organic Food",
    size: "200g",
    category: "Spices & Ingredients"
  },
   {
    id: 31,
    proImg:cookies ,
    singImg:cookies,
    title: "ኮኪስ",  // Berbere Spice
    slug: "berbere-spice",
    brand: "Organic Food",
    size: "200g",
    category: "Spices & Ingredients"
  },
];



const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const ShopPageSection = ({ addToCart }) => {
    const [shopeTab, setShopeTab] = useState(0);
    const [filter, setFilter] = useState('*');
    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);

    const handleProductClick = (product) => {
        setSelectedProduct(product);
    };

    const handleCloseClick = () => {
        setSelectedProduct(null);
    };

    useEffect(() => {
        setProducts(productData);
    }, []);

    const handleFilterChange = (newFilter) => {
        setFilter(newFilter);
    };

    const filteredProducts = products.filter((product) =>
        filter === '*' || (product.category && product.category.includes(filter.slice(1)))
    );

    const addToCartProduct = (product, qty = 1) => {
        addToCart(product, qty);
    };

   return (
    <div className="shop-section section-padding">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <div className="shop-section-top-inner">
                        <div className="shoping-list">
                            <ul className="nav main-tab">
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${shopeTab === 0 ? 'active' : ''}`}
                                        onClick={() => setShopeTab(0)}
                                    >
                                        <i className="fa fa-th"></i>
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${shopeTab === 1 ? 'active' : ''}`}
                                        onClick={() => setShopeTab(1)}
                                    >
                                        <i className="fa fa-list"></i>
                                    </button>
                                </li>
                            </ul>
                        </div>
                        <div className="shoping-product">
                            <span>Showing Products 1 - {filteredProducts.length} Of {products.length} Result</span>
                        </div>
                        <div className="short-by">
                            <ul>
                                <li>Filter By :</li>
                                <li>
                                    <select 
                                        value={filter} 
                                        onChange={(e) => handleFilterChange(e.target.value)}
                                    >
                                        <option value="*">All Products</option>
                                        <option value=".Injera">Injera</option>
                                        <option value=".Catering Services">Catering Services</option>
                                        <option value=".Spices & Ingredients">Spices & Ingredients</option>
                                        <option value=".Household Needs">Household Needs</option>
                                    </select>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="tab-content">
                        {shopeTab === 0 &&
                            <div className="row">
                                {filteredProducts.length > 0 &&
                                    filteredProducts.slice(0, 12).map((product, pitem) => (
                                        <div className="col-lg-3 col-md-6 col-12" key={pitem}>
                                            <div className={`orico-product-single ${product.isInjera ? 'injera-product' : 'no-hover'}`}>
                                                <div className="orico-product-item">
                                                    <div className="orico-product-img">
                                                        <img src={product.proImg} alt="" />
                                                    </div>
                                                </div>
                                                <div className="orico-product-text">
                                                    <h2><Link onClick={ClickHandler} to={`/orders/new`}>{product.title}</Link></h2>
                                                </div>
                                                {product.isInjera && (
                                                    <div className="orico-product-text-hide">
                                                        <ul className="orico-product-link">
                                                            <li><a href="#"><i className="fi ti-heart"></i></a></li>
                                                        </ul>
                                                        <h2><Link onClick={ClickHandler} to={`/orders/new`}>{product.title}</Link></h2>
                                                        <Link to={`/orders/new`} className="cart-btn">Shop Now</Link>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        }
                        {shopeTab === 1 &&
                            <div className="row product-list">
                                {filteredProducts.length > 0 &&
                                    filteredProducts.slice(0, 4).map((product, pitem) => (
                                        <div className="col-12" key={pitem}>
                                            <div className={`orico-product-single ${product.isInjera ? 'injera-product' : 'no-hover'}`}>
                                                <div className="orico-product-item">
                                                    <div className="orico-product-img">
                                                        <img src={product.proImg} alt="" />
                                                    </div>
                                                    {product.isInjera && (
                                                      <></>
                                                        // <div className="orico-product-text-hide">
                                                        //     <ul className="orico-product-link">
                                                        //         <li><a href="#"><i className="fi ti-heart"></i></a></li>
                                                        //     </ul>
                                                        // </div>
                                                    )}
                                                </div>
                                                <div className="orico-product-text">
                                                    <h2><Link onClick={ClickHandler} to={`/orders/new`}>{product.title}</Link></h2>
                                                    <p>{product.description}</p>
                                                    <ul>
                                                        {product.features.map((feature, index) => (
                                                            <li key={index}>{feature}</li>
                                                        ))}
                                                    </ul>
                                                    {product.isInjera ? (
                                                        <Link to={`/orders/new`} className="cart-btn">Shop Now</Link>
                                                    ) : (
                                                        <a data-bs-toggle="tooltip"
                                                            data-bs-html="true"
                                                            title="Add to Cart"
                                                             ></a>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
        <div className="btns text-center ">
                                        <Link onClick={ClickHandler} to="/orders/new" className="theme-btn-s2">order Now <i className="ti-arrow-right"
                                            aria-hidden="true"></i></Link>
                                    </div>
        <PopupQuickview product={selectedProduct} handleCloseClick={handleCloseClick} />
    </div>
);
};

export default connect(null, { addToCart })(ShopPageSection);